export default function initSearchInput() {
    let socialBtn = document.querySelector('.np-share__open')
    if(socialBtn) {
        socialBtn.addEventListener('click', () => {
            socialBtn.parentNode.classList.toggle('open')
        })
    }
}